<template>
  <component v-if="isLoggedIn" :is="'script'">
    window.productFruitsUser = { username: '{{ user.email }}', email: '{{ user.email }}', firstname:
    '{{ user.name }}',
    <!--        lastname: '<<REPLACE>>',-->
    role: '{{ user.role }}', }; (function (w, d, u, c, l) { w.productFruits = w.productFruits || {};
    w.productFruits.language = l; w.productFruits.code = c; var a =
    d.getElementsByTagName('head')[0]; var r = d.createElement('script'); r.async = 1; r.src = u +
    '?c=' + c; a.appendChild(r); })(window, document,
    'https://app.productfruits.com/static/script.js', 'qvVt8JfvdW92RYan', 'en');
  </component>
</template>

<script>
export default {
  name: 'ProductFruits',
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    user() {
      return this.$store.state.user;
    },
  },
};
</script>
